import { useState } from 'react';

import Cookies from 'js-cookie';

import { NonMemberAuthStorage } from '@/utils';

export const useAuth = () => {
  const [token, setToken] = useState<string>(Cookies.get('customer_token') ?? '');
  const [loggedIn, setLoggedIn] = useState<boolean>(Cookies.get('customer_token') ? true : false);

  const isAvailable = new NonMemberAuthStorage().isAvailable();

  return {
    loggedIn,
    setLoggedIn,
    token,
    setToken,
    checkNonUser: !loggedIn && isAvailable,
  };
};
